import { gql } from "@apollo/client";

import { createNoVarsQueryHandler } from "@/client/graphql/createQueryHandler";
import type { BerthCard_BerthFieldsFragment } from "@/client/graphql/types/generated";
import { BerthCard_BerthFieldsFragmentDoc } from "@/client/graphql/types/generated";
import { makeSequentialComponent as makeSC } from "@/utils/sequential-component";

const GET_BERTH_LIST = gql`
  ${BerthCard_BerthFieldsFragmentDoc}

  query BerthSelector_UnloadingDocks {
    me {
      id
      berths(onlyVisible: true) {
        ...BerthCard_BerthFields
      }
    }
  }
`;

const queryBerths = createNoVarsQueryHandler<{
  me: {
    berths: BerthCard_BerthFieldsFragment[];
  };
}>(GET_BERTH_LIST);

const fetch = async () => {
  const { me } = await queryBerths();
  return { unloadingDocks: me.berths };
};

export const SC = makeSC(fetch, {
  swr: true,
});
